import styled from 'styled-components';
import { websiteTypographyMixin } from './websiteTypographyMixin';
export const WebsiteTypography = styled.div `
  ${({ size, kind, type }) => websiteTypographyMixin(kind, size, type)}
`;
//# sourceMappingURL=WebsiteTypography.js.map